import { EncryptionType } from "api/models";
import { KeyTitlePair } from "shared/types";

export const QUESTIONNAIRE_MAIL_SETTINGS_ENCRYPTIONS: KeyTitlePair[] = [
  { key: EncryptionType.SSL, title: "SSL" },
  { key: EncryptionType.TLS, title: "TLS" }
];
